import * as React from 'react';
import * as moment from 'moment';
import {DatePicker} from "antd";
import {MOMENT_YEAR_MONTH_FORMAT} from "../../utils/date-utils";
import locales from "../../locales";
import StaticFormItem from "../../common/form-items/StaticFormItem";

const {MonthPicker} = DatePicker;
const rentimeVirLaunchMoment = moment("2019-03-01");

interface Props {
  start?: YearMonth;
  end?: YearMonth;
  onRangePick: (start: YearMonth | undefined, end: YearMonth | undefined) => void;
  onRangeClear: () => void;
}

interface State {
  start?: moment.Moment;
  end?: moment.Moment;
}

export interface YearMonth {
  year: number;
  month: number;
}

export class YearMonthRangePicker extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    const {start, end} = props;
    this.state = {
      start: start ? moment(`${start.year}-${start.month + 1}`) : undefined,
      end: end ? moment(`${end.year}-${end.month + 1}`) : undefined
    };
  }

  public render(): React.ReactNode {
    const {start, end} = this.state;
    const quickPickerStyle: React.CSSProperties = {
      lineHeight: '24px',
      textAlign: 'right'
    };
    return (
      <>
        <StaticFormItem
          label={locales.from}
          initialValue={
            <MonthPicker
              format={MOMENT_YEAR_MONTH_FORMAT}
              value={start}
              disabledDate={this.startMonthPickerDisabledDateFn}
              onChange={this.onStartMonthChange}
              placeholder=""
              allowClear={false}
            />
          }
        />
        <StaticFormItem
          label={locales.to}
          initialValue={
            <>
              <MonthPicker
                format={MOMENT_YEAR_MONTH_FORMAT}
                value={end}
                disabledDate={this.endMonthPickerDisabledDateFn}
                onChange={this.onEndMonthChange}
                placeholder=""
                allowClear={false}
              />
              <div style={quickPickerStyle}>
                                <span>Jelenlegi <a onClick={this.pickThisYear()}>év</a> | <a
                                  onClick={this.pickThisMonth()}>hónap</a></span>
              </div>
              <div style={quickPickerStyle}>
                                <span>Múlt <a onClick={this.pickLastYear()}>év</a> | <a
                                  onClick={this.pickLastMonth()}>hónap</a></span>
              </div>
              <div style={quickPickerStyle}>
                <span><a onClick={this.pickSinceBeginning()}>összes</a></span>
              </div>
            </>
          }
        />
      </>
    );
  }

  private startMonthPickerDisabledDateFn = (current: moment.Moment | null): boolean => {
    let isDisabled = current !== null;
    if (current !== null) {
      isDisabled = current.isAfter(moment(), 'month');
      if (this.state.end) {
        isDisabled = isDisabled || current.isAfter(this.state.end, 'month');
      }
    }
    return isDisabled;
  };

  private endMonthPickerDisabledDateFn = (current: moment.Moment | null): boolean => {
    let isDisabled = current !== null;
    if (current !== null) {
      isDisabled = current.isAfter(moment(), 'month');
      if (this.state.start) {
        isDisabled = isDisabled || current.isBefore(this.state.start, 'month');
      }
    }
    return isDisabled;
  };

  private onStartMonthChange = (start: moment.Moment | null) => {
    const alignedStart = start === null ? undefined : start;
    this.pickRange(alignedStart, this.state.end);
  };

  private onEndMonthChange = (end: moment.Moment | null) => {
    const alignedEnd = end === null ? undefined : end;
    this.pickRange(this.state.start, alignedEnd);
  };

  private pickThisYear = () => (e: React.MouseEvent) => {
    e.stopPropagation();
    this.pickRange(
      moment().startOf('year'),
      moment().endOf('day')
    );
  };

  private pickThisMonth = () => (e: React.MouseEvent) => {
    e.stopPropagation();
    this.pickRange(
      moment().startOf('month'),
      moment().endOf('day')
    );
  };

  private pickLastYear = () => (e: React.MouseEvent) => {
    e.stopPropagation();
    this.pickRange(
      moment().subtract(1, 'years').startOf('year'),
      moment().subtract(1, 'years').endOf('year'),
    );
  };

  private pickLastMonth = () => (e: React.MouseEvent) => {
    e.stopPropagation();
    this.pickRange(
      moment().subtract(1, 'month').startOf('month'),
      moment().subtract(1, 'month').endOf('month'),
    );
  };

  private pickSinceBeginning = () => (e: React.MouseEvent) => {
    e.stopPropagation();
    this.pickRange(
      rentimeVirLaunchMoment,
      moment().endOf('day'),
    );
  };

  private pickRange = (start: moment.Moment | undefined, end: moment.Moment | undefined) => {
    this.setState({start, end});
    this.props.onRangePick(this.toYearMonth(start), this.toYearMonth(end));
  };

  private toYearMonth = (m: moment.Moment | undefined): YearMonth | undefined => {
    return m === undefined ? undefined : {
      year: m.get('year'),
      month: m.get('month'),
    };
  };
}


// WEBPACK FOOTER //
// ./src/statistics/utils/YearMonthRangePicker.tsx